import { GRADE_POINTS } from '../constants/grades';

export function calculateGpa(courses) {
  let totalPoints = 0;
  let totalCredits = 0;

  for (const course of courses) {
    const points = GRADE_POINTS[course.grade];
    const credits = Number(course.credits);

    if (!Number.isFinite(credits) || credits < 0.5 || credits > 50) {
      return { error: 'Each course credit must be between 0.5 and 50.' };
    }

    if (typeof points !== 'number') {
      return { error: 'Please select a valid grade for all courses.' };
    }

    totalPoints += points * credits;
    totalCredits += credits;
  }

  if (totalCredits <= 0) {
    return { error: 'Total credits must be greater than 0.' };
  }

  return {
    value: totalPoints / totalCredits,
    totalCredits,
    totalPoints
  };
}
